// src/pages/Login/Login.js
import AuthLayout from 'components/layout/AuthLayout'
import { useUser } from 'contexts/UserContext'
import LoginForm from 'forms/Login/LoginForm'
import useFetch from 'hooks/useFetch'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'wouter'

// useFetch devuelve el cuerpo del error como texto JSON
const parseError = (error) => {
  try {
    return JSON.parse(error)
  } catch {
    return null
  }
}

export default function Login() {
  const { t } = useTranslation()
  // Hook para gestionar el usuario actual
  const { setUser } = useUser()
  // Wouter - useLocation() permite cambiar de pantalla
  const [, setLocation] = useLocation()
  // useFetch(): hooks personalizados para realizar solicitudes GET, POST, PUT, DELETE
  const [requestedLogin, requestLogin] = useFetch()
  // useState(): estados para guardar datos
  const [loginError, setLoginError] = useState(null)

  // CRUD: POST (Enviar datos del formulario)
  const handleSubmitLogin = async (values) => {
    const apiCallParams = {
      url: 'auth/login',
      method: 'POST',
      body: values,
      messageKo: t('login.invalid_credentials')
    }
    await requestLogin(apiCallParams) // Realiza la solicitud POST
  }

  useEffect(() => {
    // Si la solicitud de login es exitosa y contiene datos
    if (requestedLogin.data) {
      // La API siempre devuelve el rol. Si faltara, se trata como el de menos
      // permisos (Viewer), nunca como admin.
      const userData = {
        ...requestedLogin.data,
        role: requestedLogin.data.role || 3
      }

      // Si el usuario tiene rol 2 o 3 y la API devuelve su project_id, lo guardamos
      if ((userData.role === 2 || userData.role === 3) && userData.project_id) {
        localStorage.setItem('selectedProjectId', userData.project_id)
      }

      setLocation('/') // Redirige a la página principal ('/')
      setLoginError(null) // Resetea el estado de error
      setUser(userData) // Establece el usuario obtenido en el contexto
    }
  }, [requestedLogin.data]) // Este useEffect se ejecutará cada vez que 'requestedLogin.data' cambie

  // Mostrar mensaje API: POST / PUT (Muestra notificación de éxito o error)
  useEffect(() => {
    // Si la solicitud ha sido realizada
    if (requestedLogin.isCalled) {
      // Si hay un mensaje de error
      if (requestedLogin.error) {
        const body = parseError(requestedLogin.error)
        if (body?.code === 'too_many_attempts') {
          setLoginError(t('login.too_many_attempts', { minutes: Math.max(1, Math.ceil((body.retry_after || 60) / 60)) }))
        } else {
          setLoginError(t('login.invalid_credentials'))
        }
      }
    }
  }, [requestedLogin.loading]) // Este useEffect se ejecutará cada vez que 'requestedLogin.loading' cambie

  return (
    <AuthLayout subtitle={t('login.subtitle')}>
      <LoginForm
        loginError={loginError}
        handleSubmit={handleSubmitLogin}
      />
    </AuthLayout>
  )
}
